import React, { memo } from 'react'
import ControlledSingleSelect, {
  IControlledSingleSelectProps,
} from 'transfix-form/components/ControlledSingleSelect'
import DryVanIcon from 'transfix-icons/build/DryVanIcon'
import { TEST_IDS } from '../../constants'
import { EQUIPMENT_OPTIONS } from './constants'

export interface IControlledSelectEquipmentProps
  extends Pick<IControlledSingleSelectProps, 'control' | 'name'> {}

const ControlledSelectEquipment = memo<IControlledSelectEquipmentProps>(({ control, name }) => {
  return (
    <ControlledSingleSelect
      control={control}
      name={name}
      SingleSelectProps={{
        id: name,
        label: '',
        dataTest: TEST_IDS.equipmentSelect,
        options: EQUIPMENT_OPTIONS,
        icon: <DryVanIcon size='large' />,
        clearable: false,
      }}
    />
  )
})

export default ControlledSelectEquipment
